import * as React from "react";

import Tooltip from "@components/basics/tooltip";

interface GraphTooltipProps {
  className?: string;
  children: React.ReactNode;
  width?: string;
  isOpen?: boolean;
}

export const GraphTooltip: React.FC<GraphTooltipProps> = (props) => {
  return (
    <Tooltip
      centerPointer
      pointerBottom
      isDark
      minWidth={props.width || '150px'}
      isOpen={props.isOpen || true}
    >
      {props.children}
    </Tooltip>
  );
};

export default GraphTooltip;
